import { render, staticRenderFns } from "./Point.vue?vue&type=template&id=fab8aee4&scoped=true"
import script from "./Point.vue?vue&type=script&lang=js"
export * from "./Point.vue?vue&type=script&lang=js"
import style0 from "./Point.vue?vue&type=style&index=0&id=fab8aee4&prod&lang=scss"
import style1 from "./Point.vue?vue&type=style&index=1&id=fab8aee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab8aee4",
  null
  
)

export default component.exports